import React from 'react';
import { WeekChallengePlayfulCard } from './WeekChallengePlayfulCard';
import { WeekChallengePlayfulCardDuel } from './WeekChallengePlayfulCardDuel';
import { WeekChallengePlayfulActivities } from './WeekChallengePlayfulActivities';
import { Loader } from '@/components/custom/loader';
import { Page, PageContent, PageSidebar } from '@/components/custom/page';
import { CardWrapper } from '@/components/ui/card';

export function WeekChallengePlayfulChallenges({ challenges, isLoading }) {
  if (isLoading) return <Loader />;

  return (
    <Page>
      <PageContent>
        <CardWrapper>
          <WeekChallengePlayfulCardDuel />

          {challenges?.map(item => (
            <WeekChallengePlayfulCard
              key={item.id}
              challenge={item}
            />
          ))}
        </CardWrapper>
      </PageContent>

      <PageSidebar variant="md">
        <WeekChallengePlayfulActivities conquers={challenges?.filter(item => item.done)} />
      </PageSidebar>
    </Page>
  );
}
